import React from 'react';
import Loading from '../../../shared/Loading';
import Header from './components/Header';
import NearbyEventList from './components/NearbyEventList';
import SpecificEventList from './components/SpecificEventList';
import Footer from './components/Footer';

import { mainContent } from '../styles.module.css';
import { outerContainer } from '../layout/BrowseLayout/styles.module.css';

const ThinResult = ({
  query,
  specificEvents,
  nearbyEvents,
  trackingSource,
  dataLoading,
  headerText,
  description,
  mapMode = false,
}) => {
  const specificEventsIncluded = !!specificEvents.length;

  return (
    <>
      {!specificEventsIncluded && <Header mapMode={mapMode} />}
      <div className={outerContainer}>
        <div className={mainContent}>
          {dataLoading ? (
            <Loading />
          ) : (
            <>
              {specificEventsIncluded && (
                <SpecificEventList
                  headerText={headerText}
                  events={specificEvents}
                  query={query}
                  trackingSource={trackingSource}
                />
              )}
              <NearbyEventList
                specificEventsIncluded={specificEventsIncluded}
                events={nearbyEvents}
                query={query}
                trackingSource={trackingSource}
              />

              <Footer description={description} />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ThinResult;
